import React, { Component } from "react";

import '../../style/share.css';
import '../../style/generic.css';
import HeroSectionCategory from "../Herosection/HeroSectionCategory.js";
import {  Link, useParams } from "react-router";
import * as Constanti from '../../Utils/constants.js';
import axios from "axios";
import MarkdownPreview from '@uiw/react-markdown-preview';
import moment from "moment";
import calendar from '../../images/solar_calendar-outline.png';
import timer from '../../images/proicons_timer.png';
import ios from '../../images/ios.png';
import playStore from '../../images/play.png';




class NewsDetail extends Component{
  constructor(props){
    
    super(props);
    this.state = {
      news: {},
       imageUrl:""
          }
        }
      
      handleError = () => {
              this.setState({
                  imageUrl: Constanti.url_img_new + this.props.thumbnail
              });
          }

  componentDidMount() {
    this.fetchVideo(this.props.params.id,1);
  }


  fetchVideo(id,page) {
    const api = Constanti.url_Backend + "newsDetail";
    axios.post(api, { idNews: id})
      .then(res => {
        const pers = res.data.data;
        console.log(pers);
         this.setState(prev => ({
          news: pers,
          imageUrl: Constanti.url_img_new + pers.thumbnail
          }));
      
      })
      .catch(err => console.error(err));
  }

 

  render(){
    const {news,imageUrl} = this.state;
    return (
    <>
  
  <section className="contentShareWhite padding-top-100">
  <div className="containerShare">
  <div className="left">
    <div className="categoryNews">{news.categorie?.title}</div>
    <div className="titleNews margin-bottom-16"> {news.title}</div>
    <div className="flex horizontal boxData align-center padding-bottom-24">
     <img src={calendar} width={20} height={20} alt="" className="icoShare"/>
     <div className="dataNews icoShare"> {moment(news.publish_date).format('DD/MM/YYYY')}</div>
     <div className="dataNews icoShare">-</div>
       <img src={timer} width={20} height={20} alt="" className="icoShare"/>
      <div className="dataNews"> {news.reading_time} min di lettura</div>
    </div>
    </div>
   <div className="imgShare"> <img onError={this.handleError} src={imageUrl} alt="img"></img></div>
   <div className="descriptionShare left padding-top-40 ">  <MarkdownPreview source={news.body} style={{ fontFamily: 'manrope' }}/></div>
   <div className="containerApp padding-top-80 padding-bottom-80">
   <div className="flex vertical justify-center align-center">
    <div className="padding-bottom-24 two-lines">
      Resta aggiornato su tutte le news sull'app ufficiale di Alis
    </div>
    <div className="flex horizontal justify-center gap-8 shareMobile">
    <a href="https://esempio.com" target="_blank" title="app store"><img src={ios} width={169} height={50} alt="app store"/></a>
    <a href="https://esempio.com" target="_blank" title="play store"><img src={playStore} width={169} height={50}  alt="app store"/></a>
    </div>
    </div>
   </div>
   </div>
  </section>
  
</>
    )
}
}

export default (props) => (
  <NewsDetail
      {...props}
      params={useParams()}
  />);